import PropTypes from "prop-types"
import { Link } from "react-router-dom"

const Breadcrumb = ({ title, subitems = [] }) => (
  <nav aria-label="Breadcrumb">
    <ol className="text-grey-30 text-14 tablet:overflow-x-hidden my-32 list-none overflow-x-auto whitespace-nowrap font-semibold">
      <li className="inline-flex">
        <Link className="text-black" data-lc="breadcrumb" to="/">
          Home
        </Link>
      </li>
      {subitems.map((subitem) => (
        <li
          className="inline-flex before:px-4 before:text-black before:content-['/']"
          key={subitem.title}
        >
          <Link className="text-black" data-lc="breadcrumb" to={subitem.to}>
            {subitem.title}
          </Link>
        </li>
      ))}
      <li className="inline-flex before:px-4 before:text-black before:content-['/']">
        {title}
      </li>
    </ol>
  </nav>
)

Breadcrumb.propTypes = {
  subitems: PropTypes.array,
  title: PropTypes.string,
}

export default Breadcrumb
